module.exports = __webpack_public_path__ + "img/public/siteImages/footernewBg.svg?703aa248";